import type { RouteObject } from 'react-router';

import { PATHNAMES } from 'constants/constants';
import { lazyRoute } from 'utils/lazyRoute';

const InventionDisclosure = lazyRoute(
  () => import('features/Launchpad/components'),
  m => m.InventionDisclosure,
);

export const inventionDisclosureRoutes: RouteObject[] = [
  { path: `${PATHNAMES.inventionDisclosure}/:id`, lazy: InventionDisclosure },
];
